<app-doc-viewer title="Various dialogs" subtitle="Common">
  <app-example-viewer codeFolder="common/dialog">
    <section>
      <div class="example-label">Confirmation</div>
      <div class="example-button-row">
        <button
          mat-flat-button
          type="button"
          color="primary"
          (click)="confirm()"
        >
          Base dialog
        </button>
        <button mat-flat-button type="button" color="primary" (click)="yesno()">
          Yes/no confirm dialog
        </button>
      </div>
    </section>
    <mat-divider />

    <section>
      <div class="example-label">Custom selectors</div>
      <div class="example-button-row">
        <button mat-flat-button type="button" color="primary" (click)="check()">
          Open a dialog to select values by checkboxes
        </button>
        <button mat-flat-button type="button" color="primary" (click)="radio()">
          Open a dialog to select values by radio buttons
        </button>
      </div>
    </section>
    <mat-divider />
    <section>
      <div class="example-label">Form based</div>
      <div class="example-button-row">
        <button mat-flat-button type="button" color="primary" (click)="form()">
          Basic form
        </button>
        <button mat-flat-button type="button" color="primary" (click)="email()">
          Email
        </button>
      </div>
    </section>
    <mat-divider />
    <section>
      <div class="example-label">Renderer</div>
      <div class="example-button-row">
        <button mat-flat-button type="button" color="primary" (click)="json()">
          Open a dialog to open a json
        </button>
      </div>
    </section>
  </app-example-viewer>
</app-doc-viewer>
